import React, { VoidFunctionComponent } from 'react';
import {dispatchProductSheetQuestionsResponsesHandleClick} from "@/animations/responsive/productPageTracking";
import { LAYER_TYPE } from '@/utils/constants';
import { pluralize } from "@/utils/responsive/utils";

interface Props {
    questionCount: number;
    setLayerType: (layerType: string) => void;
    answersCount?: number;
}

export const Questions: VoidFunctionComponent<Props> = ({ questionCount, answersCount, setLayerType }) => {

    const handleClickOnlink = () => {
        setLayerType(LAYER_TYPE.QUESTION);
        dispatchProductSheetQuestionsResponsesHandleClick( "Questions et réponses");
    }

    return (
        <div className='question' onClick={handleClickOnlink}>
            <img src={"/assets/images/responsive/icons/questions.svg"} alt='icone question' width='16' height='16' />
            <p className={answersCount === undefined ? '' : 'no-underline'}>{`${questionCount} ${pluralize(questionCount, 'Question',)}`}</p>

            {answersCount !== undefined && (
                <p className='no-underline'>{`${answersCount} ${pluralize(answersCount, 'Réponse',)}`}</p>
            )}
        </div>
    );
}


